// extracted by mini-css-extract-plugin
module.exports = {"link":"_12fde55","linkWrapper":"_d730d61","linkText":"_7b2272a","linkIcon":"_0908b88"};